"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _utils = require("@seedlang/utils");
var CookieStore = /*#__PURE__*/function () {
  function CookieStore() {
    (0, _classCallCheck2["default"])(this, CookieStore);
  }
  return (0, _createClass2["default"])(CookieStore, [{
    key: "setCookieValue",
    value: function setCookieValue(name, value) {
      (0, _utils.setCookieValue)(name, value);
    }
  }, {
    key: "getCookieValue",
    value: function getCookieValue(name) {
      return (0, _utils.getCookieValue)(name);
    }
  }]);
}();
var _default = exports["default"] = new CookieStore();